import { Injectable } from '@angular/core';

@Injectable()
export class ComponentTabController {
	_index = 0;

	get index(): number { return this._index };

	set index(index: number) {
		this._index = index;
	}

	constructor() { }
}